export let byteDataTextConverter = {
  packToString(text) {
    const parsedBytes = this.convert(text);
    if (!parsedBytes.Success) {
      return { Result: "", Success: false };
    }
    let resultText = "";
    for (let i = 0; i < parsedBytes.Result.length; i++) {
      let byteText = parsedBytes.Result[i];
      resultText += `${byteText[2]}${byteText[3]}`;
    }
    return { Result: resultText, Success: true };
  },
  convert: function (text) {
    if (this.isEquals(text, "")) {
      return { Result: [], Success: true };
    }
    // format: "sometext"
    let resultArray = [];
    if (text[0] == '"') {
      if (text[text.length - 1] != '"') {
        return { Result: [], Success: false };
      }
      for (var i = 1, textLength = text.length; i < textLength - 1; i++) {
        resultArray.push("0x" + this.byteToString(text.charCodeAt(i)));
      }
      return { Result: resultArray, Success: true };
    }
    // format: 0xff,0x81,0XF5
    if (text[0] == "0" && (text[1] == "x" || text[1] == "X")) {
      return this.tryParseFormat0xFF(text);
    }
    // format: ffFE08
    return this.tryParseFormatFF(text);
  },
  tryParseFormat0xFF: function (text) {
    let state = 0;
    let halfByte = {};
    let byteValue = 0;
    let data = [];
    for (let i = 0; i < text.length; i++, state++) {
      if (state == 5) {
        state = 0;
      }
      switch (state) {
        case 0:
          if (text[i] != "0") return { Result: [], Success: false };
          break;
        case 1:
          if (text[i] != "x" && text[i] != "X") return { Result: [], Success: false };
          break;
        case 2:
          halfByte = this.convertToByte(text.charCodeAt(i));
          if (!halfByte.Success) {
            return { Result: [], Success: false };
          }
          byteValue = halfByte.Value << 4;
          break;
        case 3:
          halfByte = this.convertToByte(text.charCodeAt(i));
          if (!halfByte.Success) {
            return { Result: [], Success: false };
          }
          byteValue += halfByte.Value;
          data.push("0x" + this.byteToString(byteValue));
          break;
        case 4:
          if (text[i] != ",") return { Result: [], Success: false };
          break;
        default:
          return { Result: [], Success: false };
      }
    }
    return { Result: data, Success: state == 4 };
  },
  tryParseFormatFF: function (text) {
    if (text.length % 2 != 0) return { Result: [], Success: false };
    let data = [];
    for (let i = 0; i < text.length; i += 2) {
      let halfByte1 = this.convertToByte(text.charCodeAt(i));
      if (!halfByte1.Success) {
        return { Result: [], Success: false };
      }
      let halfByte2 = this.convertToByte(text.charCodeAt(i + 1));
      if (!halfByte2.Success) {
        return { Result: [], Success: false };
      }
      let byteValue = (halfByte1.Value << 4) + halfByte2.Value;
      data.push("0x" + this.byteToString(byteValue));
    }
    return { Result: data, Success: true };
  },
  isEquals: function (a, b) {
    return typeof a === "string" && typeof b === "string" ? a.localeCompare(b, undefined, { sensitivity: "accent" }) === 0 : a === b;
  },
  arrayBufferToString: function (buffer) {
    return String.fromCharCode.apply(null, new Uint8Array(buffer));
  },
  stringToArrayBuffer: function (text) {
    var buffer = new ArrayBuffer(text.length); // 1 byte for each char
    var bufferView = new Uint8Array(buffer);
    for (var i = 0, textLength = text.length; i < textLength; i++) {
      bufferView[i] = text.charCodeAt(i);
    }
    return buffer;
  },
  convertToByte: function (
    inputValue // inputValue is int
  ) {
    if (inputValue >= "0".charCodeAt(0) && inputValue <= "9".charCodeAt(0)) {
      return { Value: inputValue - "0".charCodeAt(0), Success: true };
    } else if (inputValue >= "a".charCodeAt(0) && inputValue <= "f".charCodeAt(0)) {
      return { Value: inputValue - "a".charCodeAt(0) + 0x0a, Success: true };
    } else if (inputValue >= "A".charCodeAt(0) && inputValue <= "F".charCodeAt(0)) {
      return { Value: inputValue - "A".charCodeAt(0) + 0x0a, Success: true };
    }
    return { Value: 0, Success: false };
  },
  byteToString(byte) {
    return ("0" + (byte & 0xff).toString(16)).slice(-2);
  }
};
